import { Component, Input, SimpleChanges } from '@angular/core';
import { PropertyType } from '../../../../shared/models/property-type';
import { CharacteristicItem } from '../../../models/characteristic-item';
import { Report } from '../../../models/report.model';
import { CharacteristicsService } from '../../../services/characteristics.service';

@Component({
  selector: 'app-caracteristiques-read-mode',
  templateUrl: './caracteristiques-read-mode.component.html',
  styleUrls: ['./caracteristiques-read-mode.component.scss'],
})
export class CaracteristiquesReadModeComponent {
  @Input() characteristics!: Report.Characteristics;
  @Input() propertyType!: PropertyType;

  characteristicsList: CharacteristicItem[] = [];

  constructor(
    private readonly characteristicsService: CharacteristicsService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const currentCharacteristics = changes['characteristics']?.currentValue;
    if (changes['characteristics'] && currentCharacteristics) {
      this.characteristicsList =
        this.characteristicsService.initializeCharacteristicsList(
          this.characteristics,
          this.propertyType.code,
        );
    }
  }

  getStringValue(value: number): string {
    return value.toString();
  }
}
